import { render } from "./SurveyPlusSummaryStep.vue?vue&type=template&id=1e35239d&ts=true"
import script from "./SurveyPlusSummaryStep.vue?vue&type=script&lang=ts"
export * from "./SurveyPlusSummaryStep.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__